const getInputLabel = (label, isEmpty) => {
  return isEmpty ? `${label} - This field is required` : label;
};

export default getInputLabel;
